import React from 'react';

const Footer = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you for your interest. We will contact you shortly.');
  };

  return (
    <>
      {/* Contact Section */}
      <section id="contact" className="py-20 bg-slate-50 border-t border-slate-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">Ready to Build the Future?</h2>
          <p className="text-slate-600 text-lg mb-10">
            Whether you are a government entity, a giga-project, or a private enterprise, we are ready to deploy our Swedish engineering teams to realize your vision.
          </p>
          <div className="bg-white p-8 rounded-3xl shadow-xl border border-slate-100 text-left">
            <form className="space-y-6" onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <input
                  type="text"
                  className="w-full px-4 py-3 rounded-lg bg-slate-50 border border-slate-200 outline-none focus:border-green-700 focus:ring-2 focus:ring-green-100"
                  placeholder="Full Name"
                  required
                />
                <input
                  type="email"
                  className="w-full px-4 py-3 rounded-lg bg-slate-50 border border-slate-200 outline-none focus:border-green-700 focus:ring-2 focus:ring-green-100"
                  placeholder="Email Address"
                  required
                />
              </div>
              <textarea
                className="w-full px-4 py-3 rounded-lg bg-slate-50 border border-slate-200 outline-none focus:border-green-700 focus:ring-2 focus:ring-green-100 h-32"
                placeholder="Tell us about your project..."
                required
              ></textarea>
              <button className="w-full bg-slate-900 text-white font-bold py-4 rounded-xl hover:bg-green-700 transition shadow-lg">
                Send Message
              </button>
            </form>
            <div className="mt-8 pt-8 border-t border-slate-100 text-center text-slate-500 flex flex-col md:flex-row justify-center gap-6">
              <span>
                <i className="fa-solid fa-envelope mr-2"></i>
                <a href="mailto:hello@sthlmtechpartner.se" className="hover:text-green-700 transition">
                  hello@sthlmtechpartner.se
                </a>
              </span>
              <span>
                <i className="fa-solid fa-phone mr-2"></i> +46 70 588 88 06
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-900 text-slate-400 py-12 border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-6">
          <div>
            <span className="font-bold text-white text-lg tracking-tight">STHLM Tech Partner</span>
            <p className="text-xs mt-1">© 2025 Sthlmtechpartner. All Rights Reserved.</p>
          </div>
          <div className="flex gap-6 text-xl">
            <a href="#" className="hover:text-white transition">
              <i className="fab fa-linkedin"></i>
            </a>
            <a href="#" className="hover:text-white transition">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="#" className="hover:text-white transition">
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
